import VueRouter from 'vue-router'
import {Route} from "vue-router/types/router";

export class AxiosUtils {

    /**
     * エラー情報をログに出力します。
     * @param error エラー時の通信データ
     * @param route ルート
     */
    public static log(error: any, route: Route) {
        // 受信データから情報を取得
        let status = null;
        let data = null;
        if (error.response) {
            status = error.response.status;
            data = error.response.data;
        }

        // エラー情報の収集
        let json = error.toJSON();
        let message = null;
        if (json) {
            message = json.message;
        }

        // コンソールに出力
        console.log(`HTTP Error Status (${status}): URL = [${error.config.method}]${error.config.url}, Message = ${message}, Route = ${route.fullPath}, RedirectedFrom = ${route.redirectedFrom}, data = ${data}`);
    }

    /**
     * HTTPステータスコードが「401（未認証）」、且つ、戻り先URL（Auth0）が指定されているか判定します。
     * @param error エラー時の通信データ
     */
    public static isUnauthorized(error: any): boolean {
        if (error.response) {
            if (error.response.status == 401) {
                let data = error.response.data;
                if (data && data.toString().startsWith("redirect:")) {
                    return true;
                }
            }
        }
        return false;
    }

    /**
     * ログを出力し、エラー画面に遷移します。
     * 未認証エラー（401）の場合は、MyPage画面に遷移します。
     * @param error エラー時の通信データ
     * @param router ルーター
     */
    public static gotoClientErrorPage(error: any, router: VueRouter) {
        // ログに出力する
        AxiosUtils.log(error, router.currentRoute);

        // HTTPステータスコードが「401（未認証）」、且つ、戻り先URL（Auth0）が指定されている場合
        if (AxiosUtils.isUnauthorized(error)) {
            // セッションタイムアウトフラグをセッションストレージに立てる
            sessionStorage.setItem("sessionTimeout", "true");
            // MyPageにアクセス
            // カレントルートが「/client/mypage」の場合は移動できないため、location.hrefで遷移
            window.location.href = "/client/mypage";
            return;
        }

        // エラー画面に遷移
        router.push("/client/error");
    }
}